import axios from 'axios'
// @ts-ignore
import { version } from '@/../package.json';
import { useAuthStore } from '@/store';
import config from '@/config';
import {reConnectWebsocket, disconnectWebsocket} from '@/services/utils/websocket'
import { registerCacheControl } from '@/services/api/main/axios-cache-control';
import { $emitter } from '@/services/emitter';

export const api = axios.create({
  baseURL: config.api.baseURL,
  headers: {'app-version':version}
})

registerCacheControl(api);

api.interceptors.request.use((config)=>{
  const authStore = useAuthStore();
  const impersonationId = authStore.impersonation?.id;

  config.headers['Authorization'] = authStore.authToken ?? '';
  if (impersonationId) {
    config.headers['app-switch-member'] = impersonationId;
  }

  return config;
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    $emitter.emit('request-error', error);
    return Promise.reject(error);
  },
);

export function setAuthToken(token: string) {
  localStorage.setItem('auth-token', token);
  api.defaults.headers.common['Authorization'] = token;
  reConnectWebsocket();
  useAuthStore().authToken = token;
}

export function removeAuthToken() {
  localStorage.removeItem('auth-token');
  api.defaults.headers.common['Authorization'] = null;
  disconnectWebsocket();
  useAuthStore().authToken = null;
}